export default __webpack_public_path__ + "static/media/Clipboard.4a80f52a.svg";